import {createSelector} from 'reselect';
import {get} from 'lodash';

import {getTripData, getSystem} from './store';
import {getLocation} from './searchBox';
import {getSiteName} from './system';
import {parseURL, toURL} from '@homeaway/search-url-parser';

const getSearchUrlBaseParams = createSelector(
    [getTripData, getSiteName, getSystem],
    (tripData, siteName, system) => {
        const lastSearchUrl = get(system, 'cookies["ha-state-prst"].lastSearchUrl', '');
        const parsedURL = lastSearchUrl ? parseURL(lastSearchUrl, {name: siteName}) : {};
        return {
            arrival: tripData.arriveDateText,
            departure: tripData.departDateText,
            adultsCount: tripData.adults,
            childrenCount: tripData.children,
            petIncluded: tripData.hasPets,
            filter: parsedURL.filter ? parsedURL.filter : []
        };
    }
);

const getSearchUrl = createSelector(
    [getSearchUrlBaseParams, getLocation],
    (searchUrlBaseParams, location) => {
        return toURL({
            ...searchUrlBaseParams,
            q: location ? location : ''
        });
    }
);

const getSearchBaseUrl = createSelector(
    [getSearchUrlBaseParams],
    (searchUrlBaseParams) => {
        return toURL(searchUrlBaseParams);
    }
);

export default getSearchUrl;

export {getSearchUrl, getSearchBaseUrl, getSearchUrlBaseParams};
